import type { Note as NoteType } from "@/services/api";
import type { FC } from "react";
import { NoteStatusTag } from "../NoteStatusTag";
import styles from "./styles.module.scss";

type Props = {
  status: NoteType["status"];
  isShowTag?: boolean;
};

export const Status: FC<Props> = ({ status, isShowTag }) => {
  return (
    <>
      {status && isShowTag && (
        <div className={styles.tag}>
          <NoteStatusTag noteStatus={status} />
        </div>
      )}
    </>
  );
};
